import CadastrarNome from "../../componentes/form/cadastrar-nome";

export default function CadastrarConvenente() {
  return <CadastrarNome label="Cadastrar convenente" labelListagem="Convenentes" url="/convenente" />
}